import { render, staticRenderFns } from "./AlumnosTotalesPorProfeListaItem.vue?vue&type=template&id=1a2dae96&"
import script from "./AlumnosTotalesPorProfeListaItem.vue?vue&type=script&lang=js&"
export * from "./AlumnosTotalesPorProfeListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports